import { useTranslationInterface } from 'utils/hooks/useTranslation';
import { I18N_NAMESPACE } from '../constants';

export const useTranslation = () => useTranslationInterface(I18N_NAMESPACE);
